export default "__VITE_ASSET__DM9Sgthp__"